export class EditTicketCommentInput {
    public id: number = 1;
    public comment: string = '';
    public isPublic: boolean = false;
}
